import { z } from 'zod'

export const VALUE_TYPES = ['text', 'color', 'number', 'boolean', 'select'] as const

export const VariantAxisFormSchema = z.object({
  name: z.string().min(1, {
    message: 'catalog.variantAxes.form.name.required',
  }),
  code: z.string().min(1, {
    message: 'catalog.variantAxes.form.code.required',
  }),
  valueType: z.enum(VALUE_TYPES, {
    required_error: 'catalog.variantAxes.form.valueType.required',
  }),
  values: z.array(
    z.object({
      id: z.string().optional(),
      code: z.string().min(1, {
        message: 'catalog.variantAxes.form.values.code.required',
      }),
      label: z.string().min(1, {
        message: 'catalog.variantAxes.form.values.label.required',
      }),
    }),
  ),
})

export type VariantAxisFormValues = z.infer<typeof VariantAxisFormSchema>
